import { useState, useEffect } from 'react';
import { T } from '../theme';
import { ChevronDown , ArrowLeft} from 'lucide-react';
import ExpenseEntryView from './ExpenseEntryView';
import { FinanceViewTopBar, SpendBlock, ReportBar } from './NavShared';

export default function AddExpenseView({
  onSave,
  onBack,
  checkLimit,
  showUpgradePrompt,
  refreshUsage,
  categories,
  addCategory,
  onGoToDashboard,
  onGoToFinances,
  onGoToFinancial,
  onGoToTax,
  onGoToExpenses,
  onGoToCapture,
  onImportCreditCard,
  onImportBank,
  reportName,
  currentFileReportType,
  savedFiles = [],
  user,
  totalSpend,
  defaultCurrency,
  adjustmentFactor,
  ratesLoading,
  ratesError,
  expenses,
  tier,
  autoSaving,
  currentFileAccess,
  scansUsed,
  totalScansAllowed,
  onShareClick,
  onLoadClick,
  onCreateReviewLinkClick,
  topBarProps,
  autoStartCamera,
}) {
  const isNonExpense = currentFileReportType === 'credit_card' || currentFileReportType === 'bank';
  const expenseFiles = savedFiles.filter(f => f.reportType === 'expense' || !f.reportType);

  // Ensure current file appears in the list even if savedFiles hasn't loaded yet
  const expenseFilesWithCurrent = (() => {
    if (isNonExpense) return expenseFiles;
    if (!reportName) return expenseFiles;
    return expenseFiles.find(f => f.name === reportName)
      ? expenseFiles
      : [{ name: reportName }, ...expenseFiles];
  })();

  const [targetReport, setTargetReport] = useState(() =>
    isNonExpense ? (expenseFiles[0]?.name ?? null) : (reportName ?? null)
  );

  // Sync if savedFiles loads after mount
  useEffect(() => {
    if (isNonExpense && !targetReport && expenseFiles.length > 0) {
      setTargetReport(expenseFiles[0].name);
    }
  }, [isNonExpense, targetReport, expenseFiles.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ fontFamily: T.fontBody, background: T.appBg, minHeight: '100vh' }}>


  {/* Compact header */}
      <div style={{ background: T.gradNavy, padding: '14px 16px 10px', flexShrink: 0 }}>
        {topBarProps && <FinanceViewTopBar {...topBarProps} />}
        {onGoToDashboard && (
          <button
            onClick={onGoToDashboard}
            style={{ background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4, color: '#fff', fontSize: 13, fontWeight: 600, marginBottom: 6 }}
          >
            <ArrowLeft size={14} color="#fff" /> Dashboard
          </button>
        )}
      </div>


      {/* Report name and total spend */}
      <div style={{ background: T.gradNavy, padding: '3px 18px' }}>
        <div style={{ marginBottom: 3 }}>
          <ReportBar
            currentFileName={reportName}
            autoSaving={autoSaving}
            currentFileAccess={currentFileAccess}
            onShareClick={onShareClick}
            onLoadClick={onLoadClick}
            onCreateReviewLinkClick={onCreateReviewLinkClick}
          />
        </div>
        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 1 }}>
          Total Spend
        </div>
        <SpendBlock
          totalSpend={totalSpend}
          defaultCurrency={defaultCurrency}
          adjustmentFactor={adjustmentFactor}
          ratesLoading={ratesLoading}
          ratesError={ratesError}
          expenses={expenses}
          user={user}
          tier={tier}
          scansUsed={scansUsed}
          totalScansAllowed={totalScansAllowed}
          amountSize={32}
        />
      </div>

      {/* Body — file picker */}
      {/* <div style={{ padding: '14px 18px 8px' }}>
        {isNonExpense && (
          <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6 }}>
            Current file is a {currentFileReportType === 'credit_card' ? 'credit card' : 'bank'} statement. Add this expense to:
          </div>
        )}
        {!isNonExpense && (
          <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6 }}>Adding expense to:</div>
        )}
        {expenseFilesWithCurrent.length === 0 ? (
          <div style={{
            background: '#FFFBEB', border: '1px solid #FCD34D', borderRadius: 10,
            padding: '12px 14px', fontSize: 13, color: '#92400E',
          }}>
            No expense reports found. Load or create an expense report first.
          </div>
        ) : (
          <div style={{ position: 'relative' }}>
            <select
              value={targetReport ?? ''}
              onChange={e => setTargetReport(e.target.value)}
              style={{
                width: '100%', padding: '10px 36px 10px 12px', borderRadius: 10,
                border: `1.5px solid ${T.tealDeep}`, fontSize: 14, fontWeight: 700,
                background: T.tealPale, color: T.tealDeep,
                appearance: 'none', cursor: 'pointer',
              }}
            >
              {expenseFilesWithCurrent.map(f => (
                <option key={f.name} value={f.name}>{f.name}</option>
              ))}
            </select>
            <ChevronDown size={16} color={T.tealDeep} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
          </div>
        )}
      </div> */}

      <div style={{ paddingBottom: 100 }}>
        {targetReport && (
          <ExpenseEntryView
            onSave={(formData) => onSave(formData, targetReport)}
            onCancel={onBack}
            checkLimit={checkLimit}
            showUpgradePrompt={showUpgradePrompt}
            refreshUsage={refreshUsage}
            categories={categories}
            addCategory={addCategory}
            autoStartCamera={autoStartCamera}
            targetReport={targetReport}
            expenseFiles={expenseFilesWithCurrent}
            onReportChange={setTargetReport}
          />
        )}
      </div>

    </div>
  );
}
